var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCopyLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 6.6V3.9C7.50002 3.66131 7.59485 3.43239 7.76363 3.2636C7.93241 3.09482 8.16133 3 8.40002 3H19.2C19.4387 3 19.6676 3.09482 19.8364 3.2636C20.0052 3.43239 20.1 3.66131 20.1 3.9V16.5C20.1 16.7387 20.0052 16.9676 19.8364 17.1364C19.6676 17.3052 19.4387 17.4 19.2 17.4H16.5V20.1C16.5 20.5968 16.095 21 15.5937 21H4.80632C4.68764 21.0007 4.56998 20.978 4.46011 20.9331C4.35025 20.8882 4.25033 20.822 4.16612 20.7384C4.0819 20.6547 4.01504 20.5553 3.96937 20.4457C3.92371 20.3362 3.90014 20.2187 3.90002 20.1L3.90272 7.5C3.90272 7.0032 4.30772 6.6 4.80902 6.6H7.50002ZM5.70272 8.4L5.70002 19.2H14.7V8.4H5.70272ZM9.30002 6.6H16.5V15.6H18.3V4.8H9.30002V6.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCopyLine);
export default __webpack_public_path__ + "static/media/file-copy-line.85ce155dd8a4d20aa02841574c207e6c.svg";
export { ForwardRef as ReactComponent };